import { ReferralLinkCollectionItem } from '../../../types/responses/referral-links'
import { ReferralLinkTableRow } from './types'

export function isReferralLinkCollectionItem(
  referralLink: ReferralLinkTableRow,
): referralLink is ReferralLinkCollectionItem {
  return 'users' in referralLink
}
